/**********************************************************************************************************************/
/* FILE: hafas_webapp_controller_gui.js                                                               */
/**********************************************************************************************************************/
/* Controller GUI */
HafasWebapp.prototype.Controller.GUI = {
  jumpBackTarget: null, // Wird fuer den Ruecksprung in einen anderen Context verwendet. (Wenn Ergebnis geschlossen wird)
  pageHeaderHeight: 50,
  pageHeaderHeightXL: 190,
  goBack: function () {
    if (Hafas('#HFS_FlyInMenuContainer_Panel').hidden) { // Checks if the sidedrawer is activated, otherwise active flyouts will be closed [HDSWAPP-3937].
      Hafas.ps.pub('/map/closeAllToolboxItems',[]);
    }
    Hafas.Modules.History.goBack();
  },
  resize: function (params) {
    params = params || {windowResize: false};

    // Anpassung, sodass man von außen (bspw. Druckansicht) den Wrapper übersteuern kann
    this.webappWrap = (params.print !== undefined && params.print) ? 'HFS_PRINT' : this.webappWrap;
    var mediaQueries = (params.print !== undefined && params.print) ? Hafas.Config.Print.layoutClassMinWidths : Hafas.Config.UI.layoutClassMinWidths;

    // Beobachte die Breiten- und Höhenänderung der WebApp
    var $webappWrap = Hafas('#' + this.webappWrap, false),
    $content = Hafas('#' + this.content, false),
    webAppW = window.innerWidth,
    webAppH = window.innerHeight;

    if (!Hafas.Config.Switches.useMediaQueries) {
      webAppW = $webappWrap.offsetWidth;
    }

    // Retrieve the current layout class
    var currLayoutClass = $webappWrap.className.match(/(layout-)([a-zA-Z]*)/g);
    if (currLayoutClass) {
      currLayoutClass = currLayoutClass[0].split('-')[1];
    } else {
      currLayoutClass = '';
    }

    // Verify if the class list includes certain classes.
    // If it does, add these specific classes to the existingClasses array.
    var classesToAdd = [];
    var extraClasses = ['lyr_debugA11yTesting', 'lyr_terminalMode', 'lyr_tooltipOverlay_show', 'lyr_onboardingTooltipWrapper'];
    extraClasses.forEach(function (className) {
      if($webappWrap.classList.contains(className)) {
        classesToAdd.push(className);
      }
    });

    // Resetting the layout class
    var _className = (Hafas.Config.UI.forceLayoutClass) ? 'lyr_wrapApplication forcedLayout' : 'lyr_wrapApplication no-forcedLayout';
    $webappWrap.className = _className;
    // Add classes from the classesToAdd array to the classlist, but only if they are specified in classesToAdd.
    if (classesToAdd.length !== 0) {
      $webappWrap.classList.add(...classesToAdd);
    }
    // Setzen der Layout Class
    // Wenn forceLayoutClass == true, wird die WebApp nur in der deklarierten layout-Klasse betrieben
    if (Hafas.Config.UI.forceLayoutClass) {
      $webappWrap.addClassName('layout-' + Hafas.Config.UI.layoutClass);
      this.layoutClass = Hafas.Config.UI.layoutClass;
      $webappWrap.addClassName('js-map-as-single-view');

      switch (true) {
        case webAppW > mediaQueries.xLarge:
          $webappWrap.addClassName('mq-xlarge');
          break;
        case webAppW > mediaQueries.large:
          $webappWrap.addClassName('mq-large');
          break;
        case webAppW > mediaQueries.mid:
          $webappWrap.addClassName('mq-mid');
          break;
        case webAppW > mediaQueries.small:
          $webappWrap.addClassName('mq-small');
          break;
      }


    } else {
      switch (true) {
        case webAppW > mediaQueries.xLarge:
          $webappWrap.addClassName('layout-xlarge');
          this.layoutClass = 'xlarge';
          break;
        case webAppW > mediaQueries.large:
          $webappWrap.addClassName('layout-large');
          this.layoutClass = 'large';
          break;
        case webAppW > mediaQueries.mid:
          $webappWrap.addClassName('layout-mid');
          this.layoutClass = 'mid';
          break;
        case webAppW > mediaQueries.small:
          $webappWrap.addClassName('layout-small');
          $webappWrap.addClassName('js-map-as-single-view');
          this.layoutClass = 'small';
          break;
      }
    }

    // Ganzen Kamin scrollen, wenn Höhe <= 650px
    var $pageScrollContainer = Hafas('#HFS_PageContentScroll');
    // Abfrage, ob es den Container gibt, notwendig für Print Configurator
    // Dort werden sonst JS Fehler geworden /mroe
    if($pageScrollContainer) {
      if (webAppH <= 650) {
        $pageScrollContainer.addClassName('lyr_flexScrolledContainer');
        $pageScrollContainer.removeClassName('lyr_flexContainer');
      } else {
        $pageScrollContainer.removeClassName('lyr_flexScrolledContainer');
        $pageScrollContainer.addClassName('lyr_flexContainer');
      }
    }

    /* Send event if layout class changes from one to another */
    if(currLayoutClass !== this.layoutClass) {
      Hafas.ps.pub("/GUI/onLayoutChange", [this.layoutClass]);
    }

    /* Send event if layout class changes from mobile to desktop */
    if(currLayoutClass !== this.layoutClass && currLayoutClass === 'small') {
      Hafas.ps.pub("/GUI/onLayoutChangeMobileToDesktop", [this.layoutClass]);
    }

    /* Send event if layout class changes to mobile */
    if(currLayoutClass !== this.layoutClass && this.layoutClass === 'small') {
      Hafas.ps.pub("/GUI/onLayoutChangeToMobile", [this.layoutClass]);
    }

    if (Hafas.Modules.IFrameApi)
      Hafas.Modules.IFrameApi.sendLayoutClassChange(this.layoutClass);

    if (Hafas.Config.TP && Hafas.Config.TP.unifiedPlanner.show) {
      $webappWrap.addClassName('formonresult');
    }

    // resize map in height (Necessity of full screen mode for integrations)
    var mapDiv = Hafas('#HFS_PageMap');
    var mapHeight = window.innerHeight + 'px';
    if (mapDiv && mapDiv.style.height !== mapHeight) mapDiv.style.height = mapHeight;

    if (this.layoutClass !== 'small') {
      Hafas.Util.gui.setVisibility(Hafas("#HFS_PageContent"), true);
      Hafas.Util.gui.setVisibility(Hafas("#HFS_TabNavigation"), true);
      if(Hafas.Config.UI.showAsWebView){
        Hafas.Util.gui.setVisibility(Hafas("#HFS_TabNavigation"), false);
      }
      Hafas.ps.pub('/GUI/map/resetDimension');
      if (typeof this.Controller.Map.instance != 'undefined' && this.Controller.Map.instance != null) { // Release Strawberry_1.3.0
        var _offset = Hafas.Util.gui.getResultsContainerWidth();
        this.Controller.Map.instance.setOffset({
          x: _offset + 30,
          y: 30
        });
      }
    } else {
      if (typeof this.Controller.Map.instance != 'undefined' && this.Controller.Map.instance != null) { // Release Strawberry_1.3.0
        var currPageHeaderHeight = this.Controller.GUI.pageHeaderHeight;
        if (this.appContext == 'LineSearch') {
          currPageHeaderHeight = this.Controller.GUI.pageHeaderHeightXL;
        }
        this.Controller.Map.instance.setOffset({
          x: 0,
          y: currPageHeaderHeight // pageHeader-Höhe muss einberechnet werden
        });
      }
    }

    // close PageNavigation
    Hafas.ps.pub('/GUI/navigation/close', [{target: 'PageNavigation'}]);

    // "small" repräsentiert den SmartphoneView.
    // Hier müssen einige UI-Events zusätzlich bzw. anders gefeuert werden
    if ((currLayoutClass !== this.layoutClass) && this.layoutClass !== 'small') {
      // Zurücksetzen der KartenTabs auf den Formularseiten
      Hafas.ps.pub('/GUI/tabs/closeAll');

      var _target = null;
      switch (this.appContext) {
        case 'TP':
          _target = 'FavLocationsTP';
          break;
        case 'SQ':
          _target = 'FavLocationsSQ';
          break;
        default:
          _target = null
      }
      Hafas.ps.pub('/GUI/tabs/switch', [{
        trigger: null,
        ev: null,
        target: _target
      }]);
    }

    // Höhen der wichtigsten Container berechnen und setzen
    Hafas.ps.pub('/GUI/common/fixedElements/setHeights', [{me: this}]);

    if (Hafas.Config.Switches.useSidedrawer) {
      // recalculate map sidedrawer
      Hafas.ps.pub('/map/sidedrawer/resize');
    }

    // duration bar: recalculation
    if(Hafas.Config.Switches.useTravelplanner) {
      Hafas.ps.pub('/GUI/durationBar/recalculate', [{mq: this.mq}]);
    }
    Hafas.ps.pub('/GUI/common/pageContentToggle', [{trigger: 'resize'}]);


    // resize SuggestInstances
    var suggestInstances = Hafas.Modules.Suggest.getSuggestInstances();
    suggestInstances.forEach(function (suggestInstance) {
      suggestInstance.resize();
    });

  },
  setBackJumpTarget: function (target) {
    if (target) {
      this.Controller.GUI.jumpBackTarget = {
        context: target.context,
        method: target.method
      };
    } else {
      this.Controller.GUI.jumpBackTarget = null;
    }
  },
  common: {
    jumpBack: function () {
      if (this.Controller.GUI.jumpBackTarget == null)
        return;
      Hafas.ps.pub('/app/switchContext', [this.Controller.GUI.jumpBackTarget]);
      Hafas.ps.pub('/GUI/form/hide', []);
      this.Controller.GUI.jumpBackTarget = null;
    },
    /**
     * Diese Funktion leitet einen Klick an den Button mit dem ersten angegebenen selector weiter.
     * Außerdem muss der gefundene Button vom HTML-Tag `<button>` sein.
     *
     * @method Controller.GUI.common.forwardClick(data)
     * @param data
     *  {String} data.selector = Hafas(selector)
     *  {DOM-Element} data.trigger = this
     *
     */
    atomForwardClick: function (data) {
      if (typeof data === "object") {
        if (typeof data.selector === "string") {
          var forwardClickedButton = Hafas(data.selector, true, data.trigger);
          if (Array.isArray(forwardClickedButton)) {
            forwardClickedButton = forwardClickedButton[0];
          }
          if (typeof forwardClickedButton !== "undefined" &&
          forwardClickedButton !== null &&
          forwardClickedButton.tagName.toLowerCase() === "button") {
            if (forwardClickedButton.hasAttribute('onclick') &&
            typeof forwardClickedButton.click === "function") {
              forwardClickedButton.click();
            } else {
              console.warn('HafasWebapp.prototype.Controller.GUI.common.atomForwardClick: Found element with "data.selector" has not onclick="...".');
            }
          } else {
            console.warn('HafasWebapp.prototype.Controller.GUI.common.atomForwardClick: Found element with "data.selector" is not <button>.');
          }
        } else {
          console.warn('HafasWebapp.prototype.Controller.GUI.common.atomForwardClick: Attribute "data.selector" must be a string.');
        }
      } else {
        console.warn('HafasWebapp.prototype.Controller.GUI.common.atomForwardClick: "data" must be a object.');
      }
    },
    /**
     * Diese Funktion leitet bei einem Key-Event den Druck auf SPACE oder ENTER an den Click-Handler weiter.
     * Wird verwendet, um divs mit role=button wie native Buttons funktionieren zu lassen
     *
     * @method Controller.GUI.common.atomForwardKeyToClick
     * @param {KeyEvent} event Das Event aus dem Key-Handler
     * @param {DOMElement} element Das Element, von dem das Event kommt und an dessen Klick-Handler es weitergeleitet werden soll
     */
    atomForwardKeyToClick: function (event, element) {
      // In FF ist keyCode "0" wenn SPACE gedrückt wird. Stattdessen steht der Code dann in "charCode"
      var code = event.charCode || event.keyCode;
      var codes = Hafas.Util.keycode;

      if (code === codes.ENTER ||
      code === codes.SPACE) {
        event.preventDefault();
        element.click();
      }
    },
    /**
     * Diese Funktion öffnet und schließt (toggle) einen oder mehrere DOM-Container (anhand ARIA-Attribute und hidden-Attribute).
     * Ein DOM-Button `<button>` wird mit dem Attribute "aria-controls" mit DOM-Container (space separiert) verknüpft.
     *
     * Der DOM-Container wird mit `hidden` ausgeblendet und der DOM-Button bekommt ein `aria-expanded="true"`.
     * Darstellung des Buttons kann somit mit `[aria-expanded="true"]` oder `[aria-expanded="false"]` beeinflusst werden.
     *
     * Mit der `prevContId` können mehrere Buttons zusammengefügt werden, um somit mehrfach geöffnete Container zu unterbinden.
     * Ohne diese `prevContId` können die Container unabhängig geöffnet werden.
     *
     * @method Controller.GUI.common.atomToggleContainer
     * @param data {Object}
     * data.open = Status der Sichtbarkeit
     * data.surrounding = Blendet benachbarte Container aus oder ein.
     * data.blockFocus = begrenzt Fokus auf den übergebenen Container
     * data.trigger = clickedElement
     * data.prevContId = previousContainerId
     * data.scroll = scroll to open container
     */
    atomToggleContainer: function (data) {
      // Auslösenden Button feststellen, wenn nicht dieser übergeben wurde, sondern der zu schließende Container
      if (!data.hasOwnProperty('trigger') && data.hasOwnProperty('target')) {
        var targetElement = Hafas("#" + data.target);
        // aria-labelledby was removed from spans/divs in HDSWAPP-3082, so we need another way to mark the trigger, now: data-trigger can be used
        var triggerId = targetElement.getAttribute('aria-labelledby') || targetElement.getAttribute('data-trigger');
        data.trigger = Hafas("#" + triggerId);
      }
      // console.log("atomToggleContainer", data, this);
      if (!data || !data.trigger) {
        console.warn('HafasWebapp.prototype.Controller.GUI.common.atomToggleContainer: Missing "data.trigger" attribute in onclick-event.');
        return;
      }

      var _me = this;
      var clickedButton = data.trigger;

      if (!(clickedButton.tagName.toLowerCase() === "button" ||
      clickedButton.getAttribute('role') === "button") &&
      !clickedButton.hasAttribute('aria-controls')) {
        console.warn('HafasWebapp.prototype.Controller.GUI.common.atomToggleContainer: Missing "aria-controls" attribute on <button>.');
        return;
      }

      // https://www.w3.org/TR/wai-aria/#aria-controls - is a ID list (Could contain more than one)
      var ariaControls = clickedButton.getAttribute('aria-controls');
      var containerIds = ariaControls.split(' ');
      var guiCommon = _me.Controller.GUI.common;
      var atomStore = guiCommon.atomStorePreviousToggleButtons;

      // Eventuell möchte man alte Container wieder ausblenden
      if (typeof data.prevContId === "string" &&
      typeof atomStore === "object" &&
      atomStore[data.prevContId] &&
      clickedButton !== atomStore[data.prevContId]) {
        // Eigener Aufruf um alle verknüfte Container auszublenden
        Hafas.ps.pub('/GUI/common/atomToggleContainer', [{
          trigger: atomStore[data.prevContId],
          prevContId: data.prevContId,
          event: data.event
        }]);
        // Lösche Referenz des DOM-Buttons
        atomStore[data.prevContId] = null;
      }

      // Ermittel den Sichtbarkeitsstatus und wende aria-expanded an.
      var newExpandedStatus = true;
      // übergebener Status ob Sichtbar/Offen oder geschlossen
      if (data.hasOwnProperty('open')) {
        newExpandedStatus = data.open;
      } else if (clickedButton.getAttribute('aria-expanded') === "false" || !clickedButton.hasAttribute('aria-expanded')) {
        newExpandedStatus = true;
        // Buttons im Array speichern ab, um alle Container der id zu schließen
        if (data.prevContId) {
          if (typeof data.prevContId === "string") {
            // Erstelle dynamisch die IdListe
            if (typeof atomStore !== "object") {
              guiCommon.atomStorePreviousToggleButtons = {};
            }
            atomStore[data.prevContId] = clickedButton;
          } else {
            console.warn('HafasWebapp.prototype.Controller.GUI.common.atomToggleContainer: Attribute "data.prevContId" must be a string.');
          }
        }
      } else {
        newExpandedStatus = false;
        if (typeof data.prevContId === "string" &&
        typeof atomStore[data.prevContId] !== "undefined" &&
        atomStore[data.prevContId] !== null) {
          // Alte Container zurücksetzen
          atomStore[data.prevContId] = null;
        }
      }

      var expandedStatusChanged = (clickedButton.getAttribute('aria-expanded') === 'true') !== newExpandedStatus;
      if (clickedButton.hasAttribute('aria-expanded')) {
        clickedButton.setAttribute('aria-expanded', newExpandedStatus);
      }
      var containerFound = false;

      if (expandedStatusChanged) {
        containerIds.forEach(function changeContainers(containerId) {
          // Genannten Container einblenden
          var containerToToggle = Hafas('#' + containerId);
          var containerVisibileStatus = !Hafas.Util.gui.isVisible(containerToToggle);
          if (containerToToggle) {
            // unlockFocus sollte vor dem Ausblenden angewendet werden.
            if (data.hasOwnProperty('blockFocus') && data.blockFocus === true && !containerVisibileStatus) {
              Hafas.Util.gui.dialog.unlockFocus(containerToToggle);
            }
            // Blendet umliegende Container mit aria-hidden aus.
            if (data.hasOwnProperty('surrounding') && data.surrounding === true) {
              if (containerVisibileStatus) {
                Hafas.Util.gui.dialog.hideSurrounding(containerToToggle);
              } else {
                Hafas.Util.gui.dialog.showSurrounding(containerToToggle);
              }
            }
            Hafas.Util.gui.setVisibility(containerToToggle, containerVisibileStatus);

            // Blockt den Fokus auf den Container
            if (data.hasOwnProperty('blockFocus') && data.blockFocus === true && newExpandedStatus) {
              Hafas.Util.gui.dialog.blockFocus(containerToToggle);
            }

            // Scroll to container if container open
            if (containerVisibileStatus === true && data.hasOwnProperty('scroll') && data.scroll === true) {
              Hafas.Util.gui.scrollToElement(containerToToggle);
            }
            containerFound = true;
          }
        });
        if (!containerFound) console.warn('HafasWebapp.prototype.Controller.GUI.common.atomToggleContainer: No container with "aria-controls"-Id found.');
      }
      if (data.event) {
        data.event.stopPropagation();
      }
      Hafas.ps.pub('/app/events/resize');
      return newExpandedStatus;
    },
    /**
     * @method Controller.GUI.common.atomTogglePressed
     * @param data {Object}
     * data.trigger = clickedElement
     */
    atomTogglePressed: function (data) {
      var triggeredElement = data.trigger;
      if (!triggeredElement) {
        return;
      }
      var checkedEl = triggeredElement.getAttribute('aria-pressed');
      if (checkedEl != null) {
        var newChecked = !JSON.parse(checkedEl);
      } else {
        var newChecked = true;
      }
      triggeredElement.setAttribute('aria-pressed', newChecked);
    },
    remove: function (elementAttribute) {
      var elements = Hafas('[data-element="' + elementAttribute + '"]', true);
      for (var i = 0; i < elements.length; i++) {
        elements[i].innerHTML = "";
      }
    },
    // data.trigger: Klasse f?r alle Container, die angeklickt werden k?n (optional)
    // data.source: der angeklickte Container (this) (obligatorisch)
    // data.target: Klasse f?r alle Container, die ge?et/geschlossen werden sollen (optional)
    // data.containerId: Der Container, der aktuell ge?et/geschlossen werden soll (obligatorisch)
    toggle: function (data) {
      if (typeof data.trigger != "undefined") {
        var triggerContainer = document.getElementsByClassName(data.trigger);
      }
      if (typeof data.target != "undefined") {
        var targetContainer = document.getElementsByClassName(data.target);
        for (var i = 0; i < targetContainer.length; i++) {
          targetContainer[i].style.display = 'none';
        }
      }

      if ((typeof data.target != "undefined") && (typeof data.trigger != "undefined")) {
        for (var i = 0; i < targetContainer.length; i++) {
          if (typeof data.trigger != "undefined") {
            triggerContainer[i].setAttribute("aria-selected", false);
          }
        }
      }

      var currentContainer = Hafas('#' + data.containerId);
      var currentContainerStyle = currentContainer.style.display;
      if (currentContainerStyle == "block") {
        currentContainer.style.display = 'none';
        data.source.setAttribute("aria-selected", false);
      } else {
        currentContainer.style.display = 'block';
        data.source.setAttribute("aria-selected", true);
      }
      Hafas.ps.pub('/app/events/resize');
    },
    /**
     * Renders the cookie hint template and checks the boxes based on storage
     * Does not show the cookie hint popup
     * @method renderCookieHint
     */
    renderCookieHint: function () {
      var targetContainer = Hafas('#HFS_CookieHint');
      var storage = Hafas.Core.newType("hafasStorage");
      var cookieAcceptance = storage.get(Hafas.Config.Storage.id+ '_cookieSettings');

      var cookieOpts = Hafas.Config.Cookies.types;

      if(cookieAcceptance != null){
        cookieAcceptance = JSON.parse(cookieAcceptance);
        for(var o=0; o < cookieOpts.length;o++){
          if(cookieAcceptance[cookieOpts[o].id] !== undefined){
            cookieOpts[o].checked = cookieAcceptance[cookieOpts[o].id];
          }
        }
      }
      Hafas.Modules.Render.render({
        file: 'common.base.html',
        target: targetContainer,
        template: 'Common_TplCookieHint',
        model: {
          cookieOptions: cookieOpts
        }
      },
      function (response) {
      });
    },

    hideCookieHint: function () {
      var targetContainer = Hafas('#HFS_CookieHint');
      Hafas.Util.gui.dialog.close(targetContainer);
      var storage = Hafas.Core.newType("hafasStorage");
      storage.set('cookieAcceptance_' + Hafas.Config.Storage.id, true);
    },
    /**
     * A function has been used for which certain cookies must be accepted: Show external or internal cookie banner.
     * @param {array<String>} [missingCookieCategories] List of missing cookie category names needed for a specific function.
     */
    showCookieSettingsHint: function(missingCookieCategories) {
      if (Hafas.Modules.IFrameApi && Hafas.Modules.IFrameApi.externalCookieManagerActive === true) {
        // ExternalCookieManager enabled in HafasIframe/iframe api, notify the parent page to show the cookie banner
        Hafas.Modules.IFrameApi.sendShowCookieSettingsCallback(missingCookieCategories);
        return;
      }
      // Render internal small cookie overlay
      Hafas.Modules.Render.render(
      {
        file: 'common.overlays.html',
        template: 'Common_CookieSaveHint',
        model: {}
      },
      Hafas.bind(function (html) {
        Hafas.bind(this.Controller.GUI.common.hideCookieSettingsHint,this)();
        this.Controller.GUI.cookieSettingsHint = {};
        this.Controller.GUI.cookieSettingsHint.currentOverlay = Hafas.Core.newType("HafasOverlay", {
          app: this,
          outputHTML: html,
          title: Hafas.Modules.i18n.get('Cookies.t_N_CookieHeadline'),
          cssClass: 'hfs_cookieSavingHint',
          onClose: Hafas.bind(function () {
            if (Hafas.Modules.History)
              Hafas.Modules.History.removeCurrentStep("CookiePopup");
            this.Controller.GUI.cookieSettingsHint.currentOverlay = null;
          },this)
        });
      },this));
    },
    hideCookieSettingsHint: function(){
      if(this.Controller.GUI.cookieSettingsHint !== undefined && this.Controller.GUI.cookieSettingsHint.currentOverlay != null) {
        this.Controller.GUI.cookieSettingsHint.currentOverlay.close(Hafas.bind(function(){
          this.Controller.GUI.cookieSettingsHint.currentOverlay = null;
        },this));
      }
    },
    setApplicationHeader: function (opts) {
      // +++++ /GUI/common/setApplicationHeader +++++
      var $el = Hafas('#HFS_itemNavbarAppContextName', false);
      var headerName = Hafas.Modules.i18n.get(opts.appcontext + '.index.t_N_applicationName');
      setTimeout(function () {
        if(Hafas.Modules.a11y) Hafas.Modules.a11y.Announce.polite(headerName);
        if (Hafas.Config.UI.showAsWebView !== true) {
          if (headerName !== '') {
            headerName = headerName + ' - ';
          }

          headerName = headerName + Hafas.Config.client.name;
        }
        document.title = headerName;
      }, 200);

      if ($el) {
        $el.innerHTML = headerName
      }
    },
    showMenuItemInTabBar: function (appContext) {
      function _getTabName(appContext) {
        for (var i = 0; i < Hafas.Config.headerNavigation.length; i++) {
          if (Hafas.Config.headerNavigation[i].controller == appContext)
            return Hafas.Config.headerNavigation[i].applicationName;
        }
        return null;
      }

      var headerText = _getTabName(appContext);
      if (headerText == null) {
        Hafas.bind(this.Controller.GUI.common.hideMenuItemInTabBar, this)();
        return "";
      }
      if (Hafas("#HFS_TabApplicationsMenuTab") != null) {
        // TODO: setVisibility nutzen
        Hafas("#HFS_TabApplicationsMenuTab").style.display = "block";
        Hafas("#HFS_TabApplicationsMenuTabLabel").innerHTML = headerText;
        Hafas("#HFS_NavBar").addClassName("js_smallTabNav");
      }
    },
    hideMenuItemInTabBar: function () {
      if (Hafas("#HFS_TabApplicationsMenuTab") != null) {
        // TODO: setVisibility nutzen
        Hafas("#HFS_TabApplicationsMenuTab").style.display = "";
        Hafas("#HFS_TabApplicationsMenuTabLabel").innerHTML = "";
        Hafas("#HFS_NavBar").removeClassName("js_smallTabNav");
      }
    },
    getLayoutClass: function () {
      // +++++ /GUI/common/getLayoutClass +++++
      var $webappWrap = Hafas('#' + this.webappWrap, false);
      // aktuelle LayoutClass ermitteln
      var _layoutClass = $webappWrap.className.match(/(layout-)([a-zA-Z]*)/g);
      if (_layoutClass) {
        this.layoutClass = _layoutClass[0].split('-')[1];
      } else {
        this.layoutClass = '';
      }
      return this.layoutClass;
    },
    highLightingInput: function (data){
      var $inputWrap = null;
      var $input = null;
      switch (data.type) {
        case 'dep':
          $input = Hafas('#From', false);
          if ($input !== null) {
            $inputWrap = $input.closest('.lyr_tpInputWrap');
          }
          break;
        case 'arr':
          $input = Hafas('#To', false);
          if ($input !== null) {
            $inputWrap = $input.closest('.lyr_tpInputWrap');
          }
          break;
        case 'via':
          $input = Hafas('#HFS_Via' + data.viaIndex, false);
          if ($input !== null) {
            $inputWrap = $input.closest('.lyr_tpInputWrap');
          }
          break;
        case 'station':
          $input = Hafas('#Station', false);
          if ($input !== null) {
            $inputWrap = $input.closest('.lyr_sqInputWrap');
          }
          break;
        case 'linesearch':
          $input = Hafas('#HFS_searchLineInput', false);
          if ($input !== null) {
            $inputWrap = $input.closest('.lyr_lineSearchInputWrap');
          }
          break;
        case 'timetable':
          $input = Hafas('#HFS_searchTimetableLineInput', false) || Hafas('#TimetableStopInput', false);
          if ($input !== null) {
            $inputWrap = $input.closest('.lyr_timetableInputWrap');
          }
          break;
        case 'layover_hours':
          $input = Hafas('#HFS_ViaDuration_hours', false);
          if ($input !== null) {
            $inputWrap = $input;
          }
          break;
        case 'layover_minutes':
          $input = Hafas('#HFS_ViaDuration_minutes', false);
          if ($input !== null) {
            $inputWrap = $input;
          }
          break;
        case 'element':
          $inputWrap = data.element || null;
          break;
        default:
      }
      var className = data.className || 'js_highLighting';
      if($inputWrap !== null) {
        $inputWrap.classList.add(className);
        if (data.keepClass === undefined || data.keepClass == false) {
          setTimeout(function () {
            $inputWrap.classList.remove(className);
          }, 2000)
        }
      }
    },
    removeHighLightingInput: function(data){
      var $inputWrap = null;
      var $input = null;
      switch (data.type) {
        case 'dep':
          $input = Hafas('#From', false);
          if ($input !== null) {
            $inputWrap = $input.closest('.lyr_tpInputWrap');
          }
          break;
        case 'arr':
          $input = Hafas('#To', false);
          if ($input !== null) {
            $inputWrap = $input.closest('.lyr_tpInputWrap');
          }
          break;
        case 'via':
          $input = Hafas('#HFS_Via' + data.viaIndex, false);
          if ($input !== null) {
            $inputWrap = $input.closest('.lyr_tpInputWrap');
          }
        case 'element':
          $inputWrap = data.element || null;
          break;
        default:
      }
      var className = data.className || 'js_highLighting';
      if ($inputWrap !== null) {
        $inputWrap.classList.remove(className);
      }
    },
    closeFavoritesPopover : function (el,topic){
      Hafas.ps.pub(topic, [])
    },

    /**
     Displays a single onboarding overlay.
     @function showSingleOnboardingOverlay
     @params {Object} params contains parameters to initialize the onboarding tooltip
     @params {String} params.id contains a reference to the onboarding tooltip config entry (Hafas.Config.Onboarding)
     @params {String} params.context contains a WebApp context to look for in the Onboarding Config
     @returns {boolean} Returns false if the onboarding tooltip cannot be rendered.
     */

    showOnboardingToolTip: function (params){
      params = params || {};
      var anchorElement = params.anchorElement;
      var webappContainer = Hafas('#HFS_WebApp', false);
      if(anchorElement === null){
        console.warn('The onboarding tooltip can\'t be render because of the following:\n  1- There is no element assigned.\n  2- There are multi elements found have a single onboarding function.\n  3- Please ensure that you use class "lyr_onboardingTooltip" to assign the element.');
        return false;
      }

      // Check if id and context are provided
      if(!params?.id || !params?.context){
        console.warn("Parameters for showing onboarding tooltip are incomplete. Please check whether 'id' and/or 'context' are missing");
        return;
      }

      var uniqueOnboardingHintId = params.context + "_" + params.id;

      // Check if the onboardingConfigItem exists, if not, set it to null [HDSWAPP-3990].
      var onboardingConfigItem = Hafas.Config.Onboarding?.[params.context]?.[params.id];
      var storageContentParsed = {};

      var storage = Hafas.Core.newType("hafasStorage");
      var storageOnboardingTooltips = storage.get(Hafas.Config.Storage.id+ '_OnboardingTooltips');
      if(storageOnboardingTooltips){
         storageContentParsed = JSON.parse(storageOnboardingTooltips);
      }

      // Function which recalculates the halo of a highlighted menu item
      var highlightDimensions = function(){
        var highlighting = {};
        if (anchorElement === null) {
          // Element might be null on resize
          return;
        }
        var highlightingElmBounding = anchorElement.getBoundingClientRect();

        var highlightingLeft = highlightingElmBounding.left - (params.highlightingPadding ? (params.highlightingPadding/2) : 0);
        var highlightingTop = highlightingElmBounding.top - (params.highlightingPadding ? (params.highlightingPadding/2) : 0);

        highlighting.width  = highlightingElmBounding.width + (params.highlightingPadding ? params.highlightingPadding: 0);
        highlighting.height = highlightingElmBounding.height + (params.highlightingPadding ? params.highlightingPadding: 0);
        highlighting.left   = highlightingLeft.toFixed();
        highlighting.top    = highlightingTop.toFixed() ;

        for(var prop in highlighting) {
          webappContainer.style.setProperty('--lyr-highlighting_' + prop, highlighting[prop]  + 'px');
        }
        if (Hafas.Util.getLayoutClass() === 'small') {
          webappContainer.style.setProperty('--lyr-highlighting_zindex', 100001);
        }
      }

      // Check if CookieSettings Popup exists and is open - then preventInitialFocus of Onboarding Tooltip
      var cookieHintElement = Hafas('#HFS_CookieHint');
      var preventFocus = new Boolean(false);
      if (cookieHintElement) {
        preventFocus = !cookieHintElement.hidden;
      }

      // Check if there is a local storage entry already or if it's been outdated, in both cases we show the tooltip
      if(onboardingConfigItem && (storageContentParsed[uniqueOnboardingHintId] === undefined ||
      onboardingConfigItem.invalidateTimestamp != storageContentParsed[uniqueOnboardingHintId])){
        Hafas.Modules.Render.render({
          file: 'common.overlays.html',
          template: onboardingConfigItem.tpl,
          model: {}
        }, function (onboardingTooltipContent) {
          this.Controller.GUI.OnboardingTooltip = {};
          this.Controller.GUI.OnboardingTooltip.currentOverlay = Hafas.Core.newType("HafasOverlay", {
            app: {
              webappWrap:"HFS_WebApp"
            },
            title: Hafas.Modules.i18n.get(onboardingConfigItem.title),
            outputHTML: onboardingTooltipContent,
            anchorElement: anchorElement,
            anchoredOverlay: 'Tooltip',
            preventInitialFocus: preventFocus,
            cssClass: 'lyr_tooltipOverlay',
            context:params.context,
            onClose: Hafas.bind(function () {
              webappContainer.removeAttribute('data-onBoarding-open');
              webappContainer.removeAttribute('style');
              var storage = Hafas.Core.newType("hafasStorage");
              storageContentParsed[uniqueOnboardingHintId] = onboardingConfigItem.invalidateTimestamp;
              storage.set( Hafas.Config.Storage.id + '_OnboardingTooltips', JSON.stringify(storageContentParsed));
              this.Controller.GUI.OnboardingTooltip.currentOverlay = null;
              if(params.closeCallback !== undefined){
                params.closeCallback();
              }
            },this),
            windowResizeCallback: function(){
              if(onboardingConfigItem.invalidateTimestamp != storageContentParsed[uniqueOnboardingHintId]){
                highlightDimensions();
              }
            },
            callback: function (html, err) {
              webappContainer.setAttribute('data-onBoarding-open',uniqueOnboardingHintId);
              highlightDimensions();
              if(typeof params.openCallback === "function"){
                params.openCallback();
              }
            }
          });
        }.bind(this));
      }else{
        // We also need to fire the closeCallback function in case the tooltip is not shown so we can proceed to the next tooltip
        if(params.closeCallback !== undefined){
          params.closeCallback();
        }
      }
    },
    forcedCloseOnboardingTooltip: function (){
      var webappContainer = Hafas('#HFS_WebApp', false);
      var onBoardingTooltip = webappContainer?.getAttribute("data-onboarding-open");
      var onboardingMask = Hafas('.hfs_overlayMask', false);

      if (onBoardingTooltip) {
        if (onboardingMask) {
          onboardingMask.click();
        }
        var storage = Hafas.Core.newType("hafasStorage");
        var storageOnboardingTooltips = storage.get(Hafas.Config.Storage.id + '_OnboardingTooltips');
        var storageContentParsed = JSON.parse(storageOnboardingTooltips) || {};

        delete storageContentParsed[onBoardingTooltip];
        storage.set(Hafas.Config.Storage.id + '_OnboardingTooltips', JSON.stringify(storageContentParsed));
      }
    },

    fixedElements: {
      setHeights: function (opts) {
      },
    },
    events: {},
    messages: {
      toggleExcerptMessage: function (params) {
        Hafas.ps.pub('/GUI/common/atomToggleContainer', [{
          trigger: params.trigger,
          event: params.event
        }]);
        Hafas.ps.pub('/app/events/resize');
        params.event.stopPropagation();
        // Exzerpt-Text beim Öffnen ausblenden
        var excerptContainer = Hafas("#" + params.excId);
        if (excerptContainer != null) {
          Hafas.Util.gui.toggleVisibility(excerptContainer);
        }
      }
    },
    /**
     * Wird in switchContext() gerufen, ruft selbst nur das Atom tabNavigationHeading()
     */
    renderTabNavigationHeading: function() {
      var model = {
        pageNavigation: Hafas.Core.clone(Hafas.Config.tabNavigation)
      };
      model.pageNavigation = model.pageNavigation.concat(Hafas.Config.headerNavigation);

      // applicationName ggf. auflösen (wird benötigt, wenn useTabNavigationDesktop/useTabNavigationMobile und showPancakeMenu false eingestellt sind,
      // da dann in renderinitial nicht der applicationName aufgelöst wurde)
      // Ist der applicationName bereits aufgelöst, spuckt i18n.get() den übergebenen applicationName wieder aus
      for (var i = 0; i < model.pageNavigation.length; i++) {
        if (model.pageNavigation[i].applicationName !== undefined) {
          model.pageNavigation[i].applicationName = Hafas.Modules.i18n.get(model.pageNavigation[i].applicationName);
        }
      }

      var wrapper = Hafas('#HFS_tabNavigationHeading');
      if (wrapper && Hafas.getWebAppContext() !== 'Imprint') { // Bei SwitchContext zu Impressum nicht neu rendern -> alte Heading muss stehen bleiben
        Hafas.Util.gui.setVisibility(wrapper, true); // Wrapper immer sichtbar machen, weil möglicherweise zuvor ausgeblendet
        Hafas.Modules.Render.render({
          file: 'common.page_navigation.html',
          target: wrapper,
          template: 'Common_AtomTplTabNavigationHeadingWrapper',
          model: model
        }, function (html) {
        });
      }
    },
    setFlexBoxScroll: function () {

      var isIE11 = !!window.MSInputMethodContext && !!document.documentMode,
      newClassName = 'lyr_ie11HeightFix';
      if (!isIE11) return;
      var wait = 50;

      // remove the newClassName from all elements first
      var elems = document.getElementsByClassName(newClassName);
      [].forEach.call(elems, function (el) {
        el.classList.remove(newClassName);
      });

      HafasWebapp.prototype.Controller.GUI.setFlexBoxScrollDebouncer = HafasWebapp.prototype.Controller.GUI.setFlexBoxScrollDebouncer || Hafas.Util.debounce(function () {

        HafasWebapp.prototype.Controller.GUI.$pageContent = HafasWebapp.prototype.Controller.GUI.$pageContent || Hafas('#HFS_PageContent', false);
        HafasWebapp.prototype.Controller.GUI.$HFS_WebApp = HafasWebapp.prototype.Controller.GUI.$HFS_WebApp || Hafas('#HFS_WebApp', false);
        var $pageContent = HafasWebapp.prototype.Controller.GUI.$pageContent,
        $HFS_WebApp = HafasWebapp.prototype.Controller.GUI.$HFS_WebApp,
        newClassName = 'lyr_ie11HeightFix',
        vh = Math.max(document.documentElement.clientHeight, window.innerHeight || 0),
        flexScrolledContainers = Hafas('.lyr_flexScrolledContainer', true, $pageContent);

        /**
         *
         * @param element
         * @param executeFunction
         * @param stopElement
         * @private
         */
        function _goThroughParentElements(element, executeFunction, stopElement) {
          var parent = element.parentElement;
          stopElement = stopElement || document.body || document;
          while (parent !== null && parent !== stopElement) {
            executeFunction(parent);
            parent = parent.parentElement;
          }
        }

        if ($pageContent) {
          var containerHeight = $pageContent.offsetHeight || $pageContent.clientHeight;
          if (containerHeight >= vh) {

            flexScrolledContainers.forEach(function (el) {
              if (Hafas.Util.gui.isVisible(el)) {
                if (el.children.length !== 0) {
                  _goThroughParentElements(el, function (parent) {
                    if (!parent.classList.contains(newClassName)) parent.classList.add(newClassName);
                  }, $HFS_WebApp);
                }
              }
            });
          }
        }
      }, wait);

      HafasWebapp.prototype.Controller.GUI.setFlexBoxScrollDebouncer();

    },
    pageContentToggle: function (param) {
      var btnIcon = Hafas('.lyr_pageContentToggleBtn i', false),
      $section = Hafas('#HFS_PageContent', false),
      $section_W = $section.offsetWidth;

      if (param.show != null) {
        if (param.show === !$section.classList.contains('js_close')) {
          // pageContent is supposed to be shown but is already shown, or is supposed to be hidden but already hidden
          return;
        }
      }
      // If "show" is set, show/hide depending on value; else, show/hide depending on current state
      var show = param.show != null ? param.show : $section.classList.contains('js_close');

      if (show) {
        if (param.trigger === 'resize' && !Hafas('#HFS_WebApp', false).classList.contains('layout-small')) {
          $section_W = $section.offsetWidth;
          $section.setAttribute("style", "transform: translate(-" + $section_W + "px, 0);");
        } else {
          $section.classList.remove('js_close');
          $section.removeAttribute('style');
          btnIcon.className = 'haf_ic_scroll_step_left';
          btnIcon.parentElement.parentElement.setAttribute('aria-label', Hafas.Modules.i18n.get("common.label.t_N_Form_hide"));
        }
      } else {
        if (param.trigger === 'main') {
          $section.classList.add('js_close');
          $section.setAttribute("style", "transform: translate(-" + $section_W + "px, 0);");
          btnIcon.className = 'haf_ic_scroll_step_right';
          btnIcon.parentElement.parentElement.setAttribute('aria-label', Hafas.Modules.i18n.get("common.label.t_N_Form_show"));
        }
      }
    },
    /**
     * Tab Navigation Heading Actionbar auf Unterseiten ausblenden, da dort eine andere Actionbar existiert
     */
    hideNavigationHeading: function() {
      // Heading-Container ausblenden
      var tabNavHeadingBar = document.getElementById("HFS_tabNavigationHeading");
      Hafas.Util.gui.setVisibility(tabNavHeadingBar, false);

      // Gesamte Leiste samt Burger-Menu für mobile Layouts ausblenden, da Heading-Container auch nicht mehr sichtbar
      // und damit eine Actionbar angezeigt werden sollte
      var tabNavigation = document.getElementById("HFS_TabNavigation");
      tabNavigation.classList.add('lyr_layoutSmallHide');
      if(Hafas.Config.UI.showAsWebView){
        Hafas.Util.gui.setVisibility(tabNavHeadingBar, false);
        Hafas.Util.gui.setVisibility(tabNavigation, false);
      }
    },
    /**
     * Tab Navigation Heading Actionbar wieder einblenden, da diese beim Aufruf der Optionen ausgeblendet wurde
     */
    showNavigationHeading: function() {
      // Heading-Container wieder einblenden
      var tabNavHeadingBar = document.getElementById("HFS_tabNavigationHeading");
      Hafas.Util.gui.setVisibility(tabNavHeadingBar, true);

      // Gesamte Leiste samt Burger-Menu nicht mehr mobil ausblenden, da Heading-Container sichtbar
      var tabNavigation = document.getElementById("HFS_TabNavigation");
      tabNavigation.classList.remove('lyr_layoutSmallHide');

      // Actionbar-Container innerhalb des Tab-Containers wieder einblenden, da ggf. durch Anzeigen von Optionen ausgeblendet
      var tabNavActionbar = Hafas("[data-render-element='result_view_header']", true, tabNavHeadingBar);
      for (var i = 0; i < tabNavActionbar.length; i++) {
        Hafas.Util.gui.setVisibility(tabNavActionbar[i], true);
      }
    },
    showPageLoader: function (waitText) {
      var loader = Hafas('#HFS_PageLoader', false);
      var waitTextElement = Hafas('#HFS_PageLoaderText', false);
      if (waitTextElement) {
        if (typeof waitText === 'string') {
          waitTextElement.innerText = waitText;
        } else {
          waitTextElement.innerText = Hafas.Modules.i18n.get('common.label.t_N_Loading');
        }
      }
      if(loader) {
        Hafas.Util.gui.setVisibility(loader, true);
      }
    },
    hidePageLoader: function () {
      var loader = Hafas('#HFS_PageLoader', false);
      if(loader) {
        Hafas.Util.gui.setVisibility(loader, false);
      }
    },
    /**
     * Change the color scheme of the WebApp.
     * @param {string} switchTo - The name of the color scheme to switch to
     */
    toggleColorScheme: function (switchTo) {
      Hafas.Core.setColorScheme(switchTo);

      if (Hafas.Util.isCookieTypeActive('functional')) {
        var storage = Hafas.Core.newType("hafasStorage");
        storage.set('hfsColorScheme_' + Hafas.Config.Storage.id, switchTo);
      }
    },
    /**
     * Open an overlay containing the the given URL as a QR code
     * @param {Object} data - Data to use in the overlay
     * @param {string} data.url - The URL to display as a QR code
     * @param {string} data.title - The title of the overlay
     * @param {string} [data.description] - An optional description to display in the overlay
     * @param {string} [data.trigger] - The element that triggered the overlay
     * @param {string} [data.anchor] - The element that the overlay should be anchored to
     * @param {string} [data.centerArrow] - If overlay is anchored, place arrow in the middle of the overlay
     * @param {string} [data.forcePlacement] - If overlay is anchored, force it to be positioned above or below the anchor
     */
    showQrCodeOverlay: function (data) {
      // If there is no title, use description as title
      if (!data.title) {
        data.title = data.description;
        data.description = '';
      }
      // Generate QR code
      var qrCodeSting = Hafas.Util.createQrCodeString(data.url);

      // Render overlay with QR code
      Hafas.Modules.Render.render({
        template: 'Common_ExtContOverlay',
        file: 'common.overlays.html',
        model: {
          qrCodeString: qrCodeSting,
          description: data.description || ''
        }
      }, function (outputHTML) {
        var overlayParams = {
          app: this,
          outputHTML: outputHTML,
          title: data.title,
          cssClass: 'lyr_qrCodeOverlay',
          closeViaCancel: true,
          closeButtonTxt: 'common.label.t_N_Close'
        };
        if (data.trigger) {
          overlayParams.triggerElement = data.trigger;
        }
        if (data.anchor) {
          overlayParams.anchorElement = data.anchor;
          overlayParams.anchoredOverlay = 'DESKTOP';
          if (data.centerArrow) {
            overlayParams.centerArrow = data.centerArrow;
          }
          if (data.forcePlacement) {
            overlayParams.forcePlacement = data.forcePlacement;
          }
        }
        this.Controller.TP.tariffOverlay = Hafas.Core.newType("HafasOverlay", overlayParams);
      }.bind(this));
    }
  },

  tabs: {
    switch: function (opts) {

      // TODO: Herausgelöscht für Components.SegmentedControl

      // +++++ /GUI/tabs/switch +++++
      Hafas.ps.pub('/GUI/map/resetDimension');
    },
  },
  flyin: {
    toggle: function (opts) {
      opts = opts || {};
      // +++ /GUI/FlyIn/toggle +++
      var $pageHeader = Hafas('#HFS_FlyInMenuContainer_Panel', false);

      if ($pageHeader != null) {
        if ($pageHeader.className.match(/js_open/)) {
          Hafas.bind(this.Controller.GUI.flyin.hide, this)(opts);
          Hafas.ps.pub('/tracking/event/flyin-close', ['[' + this.appContext + '] SIDEMENU CLOSE']);
        } else {
          Hafas.bind(this.Controller.GUI.flyin.show, this)(opts);
          Hafas.ps.pub('/tracking/event/flyin-open', ['[' + this.appContext + '] SIDEMENU OPEN']);
        }
      }
    },
    show: function (opts) {
      opts = opts || {};
      var $pageHeader = Hafas('#HFS_FlyInMenuContainer_Panel', false);
      if ($pageHeader != null) {
        Hafas.Util.gui.dialog.open($pageHeader);
        // Hafas.Util.gui.setVisibility($pageHeader, true);
        $pageHeader.addClassName('js_open');

        // Ausblenden wenn kleiner Bildschirm
        var mediaQuery = window.matchMedia('(max-height: 350px)');
        if(mediaQuery.matches && this.layoutClass === 'small') {
          var pageContent = Hafas('#HFS_PageContent', false);
          if(pageContent) Hafas.Util.gui.setVisibility(pageContent, false);
        }
      }

      var menuButton = Hafas('#HFS_FlyInMenuContainer_Tab');
      if(menuButton) {
        menuButton.setAttribute('aria-expanded', 'true');
      }

      Hafas.Core.listenToEvent($pageHeader, 'keydown', HafasWebapp.prototype.Controller.GUI.flyin.keydownfunc);

      // create a toggle mask
      var $mask = document.createElement('div');
      $mask.id = "HFS_FlyinMask";
      $mask.setAttribute('aria-hidden', true);
      $mask.addClassName('lyr_flyinMask');
      $mask.onclick = function (e) {
        e.preventDefault();
        Hafas.ps.pub('/GUI/FlyIn/toggle', [{
          trigger: null,
          ev: null
        }]);
        return false;
      };
      var maskContainer = Hafas("#HFS_WebApp");
      if (maskContainer != null) {
        maskContainer.appendChild($mask);
      }

      Hafas.ps.pub('/app/updateBanner', ['sidedrawer']);

      if (Hafas.Modules.History)
        Hafas.Modules.History.addSubView("/GUI/FlyIn/hide", "FlyIn", {});

    },
    hide: function (opts) {
      opts = opts || {};
      if (Hafas.Modules.History)
        Hafas.Modules.History.removeCurrentStep("FlyIn", opts.callback);
      var $pageHeader = Hafas('#HFS_FlyInMenuContainer_Panel', false);
      $pageHeader.removeClassName('js_flyinMenu');

      var menuButton = Hafas('#HFS_FlyInMenuContainer_Tab');
      if(menuButton) {
        menuButton.setAttribute('aria-expanded', 'false');
      }

      // Hafas.Util.gui.setVisibility($pageHeader, false);
      Hafas.Util.gui.dialog.close($pageHeader, opts);

      $pageHeader.removeClassName('js_open');

      // Immer Einblenden auch wenn nicht kleiner Bildschirm
      var pageContent = Hafas('#HFS_PageContent', false);
      if(pageContent) Hafas.Util.gui.setVisibility(pageContent, true);

      var $mask = Hafas('#HFS_FlyinMask', false);
      if ($mask) {
        $mask.parentNode.removeChild($mask);
      }
    }
  },
  results: {
    resize: function (data) {
      window.setTimeout(function () {

//        Hafas.ps.pub('/app/events/resize', [{data: data}]);

      }, 100);
    },
    all: {
      hide: function (opts) {
        // +++++ /GUI/results/all/hide +++++
        var $resultOverviewContainer = Hafas('#' + this.resultOverviewContainer, false),
        $resultDetailsContainer = Hafas('#' + this.resultDetailContainer, false),
        $collInnerOverviewContainer = Hafas('#' + this.resultOverviewContainer + ' .lyr_resultOverviewContainer', true),
        $collInnerDetailsContainer = Hafas('#' + this.resultDetailContainer + ' .lyr_resultDetailContainer', true);

        Hafas.Util.gui.setVisibility($resultOverviewContainer, false);
        Hafas.Util.gui.setVisibility($resultDetailsContainer, false);

        if ($collInnerOverviewContainer) {
          $collInnerOverviewContainer.forEach(function (cont, idx) {
            Hafas.Util.gui.setVisibility(cont, false);
          });
        }
        if ($collInnerDetailsContainer) {
          $collInnerDetailsContainer.forEach(function (cont, idx) {
            Hafas.Util.gui.setVisibility(cont, false);
          });
        }


      }
    },
    cluster: {
      toggleGroup: function (type, boolval) {
        var resultGroup = Hafas('[data-result-conngroup="' + type + '"]', false);
        if (resultGroup) {
          Hafas.Util.gui.setVisibility(resultGroup, boolval);
        }
      }
    },
    overview: {
      removeActive: function (data) {

        if (typeof this.Controller.TP.activeSelection != 'undefined') {
          var item = document.getElementById('HFS_ConnectionId_' + this.Controller.TP.activeSelection.connType + '_' + this.Controller.TP.activeSelection.arrayIdx);
          if (item) {
            if (item.className.match(/js_overviewItemActive/g)) {
              item.removeClassName('js_overviewItemActive');
            }
            if (item.className.match(/js_overviewItemActive/g)) {
              item.removeClassName('js_overviewItemActive');
            }
          }
        }
      },
      setActive: function (data) {
        this.Controller.TP.activeSelection = {
          connType: data.connType,
          arrayIdx: data.arrayIdx
        };
        if (typeof data.subclusterGrpId != 'undefined') {
          this.Controller.TP.activeSelection.subclusterGrpId = data.subclusterGrpId;
        } else {
          // Wenn nicht vorhanden subsclusterGrpId wieder zurücksetzen
          delete this.Controller.TP.activeSelection.subclusterGrpId;
        }
        // Wenn der Schalter UI.showTPResultsInOverview gesetzt ist, müssen zuvor gehighlightete Verbindungen zurückgesetzt werden
        if (Hafas.Config.UI.showTPResultsInOverview) {
          var parentContainer = Hafas('#HFS_TPOverviewResults', false);
          var connectionElements = Hafas('.lyr_tpConnectionListElement', true, parentContainer);
          connectionElements.forEach(function (connGuiElem) {
            connGuiElem.removeClassName('lyr_overviewItemActive');
          });
        }
        if (typeof data.subclusterGrpId != 'undefined') {
          var currConnInOverview = document.getElementById('HFS_ConnectionId_' + data.connType + '_' + data.subclusterGrpId + '_' + data.arrayIdx);
        } else {
          var currConnInOverview = document.getElementById('HFS_ConnectionId_' + data.connType + '_' + data.arrayIdx);
        }
        if (currConnInOverview.className.match(/lyr_overviewItemActive/g)) {
          currConnInOverview.addClassName('lyr_overviewItemActive');
        } else {
          currConnInOverview.addClassName('lyr_overviewItemActive');
        }
      },
      hide: function (opts) {
        // +++++ /GUI/results/overview/hide +++++
        var ctx = this.appContext;
        var $resultOverviewContainer = Hafas('#' + this.resultOverviewContainer, false);
        var $resultOverview = Hafas('#' + this.resultOverviewContainer + ' [data-contid="' + ctx + '"]', false);
        if ($resultOverview) {
          Hafas.Util.gui.setVisibility($resultOverviewContainer, false);
          Hafas.Util.gui.setVisibility($resultOverview, false);
        }
        if (this.Controller.GUI.jumpBackTarget != null) {
          Hafas.bind(this.Controller.GUI.common.jumpBack, this)();
        }
      },
      show: function (opts) {
        // +++++ /GUI/results/overview/show +++++
        var ctx = this.appContext;

        var $resultOverviewContainer = Hafas('#' + this.resultOverviewContainer, false);
        var $resultOverview = Hafas('#' + this.resultOverviewContainer + ' [data-contid="' + ctx + '"]', false);
        if ($resultOverview) {
          Hafas.Util.gui.setVisibility($resultOverviewContainer, true);
          Hafas.Util.gui.setVisibility($resultOverview, true);
        }
      },
      showEarlierLaterFirstLastLoader: function (data) {
        var wrapper = data.trigger.parentElement;
        var loaderWrapper = document.createElement('div');
        var loaderElem = document.createElement('div');
        var loaderHtml = Hafas.Modules.Render.renderTemplate("Common_AtomTplLoaderBarInfinite", {id: "HFS_TP_ConnOverviewLoader"});
        loaderWrapper.className = 'lyr_' + data.type + 'LoaderWrap';
        loaderWrapper.innerHTML = loaderHtml;
        wrapper.appendChild(loaderWrapper);
      },
      hideEarlierLaterFirstLastLoader: function (data) {
        // Strawberry 1.6.0
        var wrapper = [];
        try {
          wrapper = Hafas('[data-scroll-connections="' + data.type + '"].hfs_actionsResult > nav', true);
        } catch (e) {
        }

        // alternativ anderes Element
        if (wrapper.length == 0) {
          wrapper = Hafas('[data-render-element="result_overview_footer"] > nav', true);
        }
        if (wrapper.length > 0) {
          if (Hafas('.js_earlierLaterLoader', false, wrapper[0])) {
            Hafas('.js_earlierLaterLoader', false, wrapper[0]).setAttribute('disabled', true);
          }
        }
      },
      disableFirstLastLink: function (elem) {
        // weitere clicks unterbinden
        elem.setAttribute('onclick', 'return false;');

      },
      hideFirstLastLink: function (firstLast, grpId) {
        var linkElem;
        var additionalDomFilter = '';
        if (grpId !== undefined) {
          additionalDomFilter = '[data-scroll-type="' + grpId + '"]';
        }

        if (firstLast == 'FRST') {
          linkElem = Hafas('#' + this.resultOverviewContainer + ' ' + additionalDomFilter + '[data-scroll-link="first"]', false);
        } else if (firstLast == 'LAST') {
          linkElem = Hafas('#' + this.resultOverviewContainer + ' ' + additionalDomFilter + '[data-scroll-link="last"]', false);
        }

        if (linkElem) {
          // deaktivieren und nicht ausblenden
          linkElem.setAttribute('disabled', true);
        }

        // Speichere gedrückte ScrollingButtons (Nur im Clusterkontext)
        this.Controller.TP.scrollButtonsState = this.Controller.TP.scrollButtonsState || {};
        if (typeof grpId !== 'undefined') {
          this.Controller.TP.scrollButtonsState[grpId] = this.Controller.TP.scrollButtonsState[grpId] || {};
          this.Controller.TP.scrollButtonsState[grpId][firstLast] = true;
        }

        // loader ausblenden
        this.Controller.GUI.results.overview.hideEarlierLaterFirstLastLoader();
      }
    },
    details: {
      hide: function (opts) {
        // +++++ /GUI/results/details/hide +++++
        var ctx = this.appContext;
        // Wenn TP.unifiedPlanner.show=true gesetzt ist, muss beim Schließen das Formular eingeblendet werden:
        var $resultDetailsContainer = Hafas('#' + this.resultDetailContainer, false);
        var $resultDetails = Hafas('#' + this.resultDetailContainer + ' [data-contid="' + ctx + '"]', false);
        if ($resultDetails) {
          Hafas.Util.gui.setVisibility($resultDetailsContainer, false);
          Hafas.Util.gui.setVisibility($resultDetails, false);
        }

      },
      show: function (opts) {
        // +++++ /GUI/results/details/show +++++
        var ctx = this.appContext;

        // Wenn TP.unifiedPlanner.show=true gesetzt ist, muss in der Detail dann das Formular ausgeblendet werden:
        if (Hafas.Config.TP?.unifiedPlanner.show && !Hafas.Util.isFormBased() && !(typeof Hafas.Config.UI.showTPResultsInOverview != 'undefined' && Hafas.Config.UI.showTPResultsInOverview == true)) {
          Hafas.ps.pub('/GUI/form/hide', [{appcontext: this.appContext}]);
        }

        // Wenn sich die Details per Konfiguration unterhalb der Verbindung in der Overview geöffnet hat
        // Dann muss von hier aus auch da wieder hingesprungen und der OverviewContainer eingeblendet werden
        if (typeof Hafas.Config.UI.showTPResultsInOverview != 'undefined' && Hafas.Config.UI.showTPResultsInOverview == true) {
          var $resultOverviewContainer = Hafas('#' + this.resultOverviewContainer, false);
          var $resultOverview = Hafas('#' + this.resultOverviewContainer + ' [data-contid="' + ctx + '"]', false);
          if ($resultOverview) {
            Hafas.Util.gui.setVisibility($resultOverviewContainer, true);
            Hafas.Util.gui.setVisibility($resultOverview, true);
          }
        } else {
          var $resultDetailsContainer = Hafas('#' + this.resultDetailContainer, false);
          var $resultDetails = Hafas('#' + this.resultDetailContainer + ' [data-contid="' + ctx + '"]', false);
          if ($resultDetails) {
            Hafas.Util.gui.setVisibility($resultDetailsContainer, true);
            Hafas.Util.gui.setVisibility($resultDetails, true);
          }
        }
      },
    },
    additional: {
      show: function (data) {
        // +++++ /GUI/results/additional/show +++++
        // close all open tabs
        Hafas.ps.pub('/GUI/tabs/closeAll');

        // set additional context to call the correct resultContainer in Element 'DocumentAdditionalContainer'
        this.additionalContext = data.additionalContext;

        Hafas.ps.pub('/GUI/results/overview/hide', [{}]);
        Hafas.ps.pub('/GUI/results/details/hide', [{}]);

        if (Hafas.Config.TP.unifiedPlanner.show) {
          Hafas.ps.pub('/GUI/form/hide', [{appcontext: this.appContext}]);
        }

        var $resultAdditionalContainer = Hafas('#' + this.additionalContainer, false);
        var $resultAdditional = Hafas('#' + this.additionalContainer + ' [data-contid="' + this.additionalContext + '"]', false);
        if ($resultAdditional) {
          Hafas.Util.gui.setVisibility($resultAdditionalContainer, true);
          Hafas.Util.gui.setVisibility($resultAdditional, true);
        }
      },
      hide: function (data) {
        // +++++ /GUI/results/additional/hide +++++
        // remove activeState in SQResultOverview
        Hafas.ps.pub('/GUI/results/overviewSQ/removeActive');

        if (Hafas.Config.TP.unifiedPlanner.show) {
          Hafas.ps.pub('/GUI/form/show', [{appcontext: this.appContext}]);
        }

        //Hafas.ps.pub('/GUI/results/overview/hide', [{}]);
        //Hafas.ps.pub('/GUI/results/details/hide', [{}]);

        // we have to clear the innerResults and reset the additionalcontext-property
        var innerResultAdditional = Hafas('#' + this.additionalContainer + ' [data-contid="' + data.additionalContext + '"]', false);
        innerResultAdditional.innerHTML = '';


        if (typeof data.independent != 'undefined' && data.independent) {
          if (this.appContext != this.prevContext) {
            Hafas.ps.pub('/app/switchContext', [{context: this.appContext}]);
          } else {
            Hafas.ps.pub('/GUI/form/show', [{appcontext: this.appContext}]);
          }
        }

        if (this.appContext === 'TP') {
          Hafas.ps.pub('/GUI/results/details/show', [{}]);
        }

        if (this.appContext === 'SQ') {
          Hafas.ps.pub('/GUI/results/overview/show', [{}]);
        }

        if (this.appContext === 'LineSearch') {
          Hafas.ps.pub('/GUI/results/overview/show', [{}]);
        }


        // removing class 'js_additionalContainerShown' from all resultcontainer to handle left positions
        // var resultContainers = Hafas('.hfs_wrapResultContainer', true),
        //     i = 0,
        //     len = resultContainers.length;
        //
        // for ( i ; i < len ; i++ ) {
        //   var cont = resultContainers[i];
        //   // Todo: remove 'js_additionalContainerShown' when closing additionalContainer
        //   cont.removeClassName('js_additionalContainerShown');
        //   cont.removeClassName('js_additionalIsSecondCol');
        // }

        Hafas.ps.pub('/app/events/resize', [{
          keepOverviewScrollPos: true,
          keepDetailsScrollPos: true
        }]);

        if (typeof data.additionalContext != 'undefined') {
          switch (data.additionalContext) {
            case 'TQ':
              // Wenn der aktuelle appContext TP ist, dann muss auch wieder die aktuelle Connection angezeigt werden.
              if (this.appContext == 'TP') {
                this.Controller.Map.showCurrentConnection();
              }
              Hafas.ps.pub('/tq/hideTrainroute', [data]);
              break;
          }
        }
      },
      hideAll: function () {

        var resultContainers = Hafas('.lyr_wrapResultContainer', true),
        i = 0,
        len = resultContainers.length;

        for (i; i < len; i++) {
          var cont = resultContainers[i];
          cont.removeClassName('js_additionalContainerShown');
          cont.removeClassName('js_additionalIsSecondCol');
        }

        var innerResultAdditional = Hafas('.lyr_resultAdditionalContainer', true),
        j = 0,
        jLen = innerResultAdditional.length;
        for (j; j < jLen; j++) {
          var cont = innerResultAdditional[j];
          cont.innerHTML = '';
        }
        Hafas.ps.pub('/app/events/resize', [{
          keepOverviewScrollPos: true,
          keepDetailsScrollPos: true
        }]);
      }
    },
    overviewSQ: {
      removeActive: function (data) {
        var parent = document.getElementsByClassName('lyr_SQOverviewResults')[0];
        if (parent) {
          Hafas.Util.removeEmptyTextNodes(parent);

          var connectionList = parent.childNodes;
          var i = 0;
          var len = connectionList.length;
          for (i; i < len; i++) {
            var item = connectionList[i];
            if (item.className.match(/js_overviewItemActive/g)) {
              item.removeClassName('js_overviewItemActive');
            }
          }
        }
      },
      setActive: function (data) {
        var currConnInOverview = document.getElementById('HFS_StationId_' + data.arrayIdx);
        currConnInOverview.addClassName('js_overviewItemActive');
      },
      tabbar: {
        toggle: function (data) {
          if (data.ev) {
            data.ev.preventDefault();
          }
          var $trigger = data.trigger;
          var $target = Hafas($trigger.getAttribute('data-dropdown'), false);

          if ($target) {
            Hafas.Util.gui.toggleVisibility($target);
          }
        },
        hide: function (data) {
          var $trigger = data.trigger;
          var $target = Hafas($trigger.getAttribute('data-dropdown'), false);
          if ($target) {
            Hafas.Util.gui.setVisibility($target, false);
          }
        }
      }
    },
    overviewHimSearch: {
      tabbar: {
        toggle: function (data) {
          if (data.ev)
            data.ev.preventDefault();
          var $trigger = data.trigger;
          var $target = Hafas($trigger.getAttribute('data-dropdown'), false);

          if ($target) {
            Hafas.Util.gui.toggleVisibility($target);
          }
        },
        hide: function (data) {
          var $trigger = data.trigger;
          var $target = Hafas($trigger.getAttribute('data-dropdown'), false);
          if ($target) {
            Hafas.Util.gui.setVisibility($target, false);
          }
        }
      }
    }
  },
  navigation: {
    toggle: function (data) {
      if (data.ev)
        data.ev.preventDefault();

      var $target = Hafas('#' + data.target, false);
      var $pageHeader = Hafas('#' + this.pageHeader, false);
      var $pageContent = Hafas('#' + this.content, false);

      if (!$pageHeader.className.match(/js_navbarOpen/)) {
        $target.addClassName('js_navbarOpen');
        $pageHeader.addClassName('js_navbarOpen');
        $pageContent.addClassName('js_navbarOpen');
        //$pageContent.style.marginTop = $pageHeader.offsetHeight + 'px';
      } else {
        Hafas.ps.pub('/GUI/navigation/close', [{target: data.target}]);
      }
    },
    close: function (data) {
      var $target = Hafas('#' + data.target, false);
      var $pageHeader = Hafas('#' + this.pageHeader, false);
      var $pageContent = Hafas('#' + this.content, false);

      if ($pageHeader.className.match(/js_navbarOpen/)) {
        $target.removeClassName('js_navbarOpen');
        $pageHeader.removeClassName('js_navbarOpen');
        $pageContent.removeClassName('js_navbarOpen');
        $pageContent.removeAttribute('style');
        Hafas.ps.pub('/app/events/resize');
      }
    }
  },
  displayResults: {
    media: function (data) {
      var overview = document.getElementById(this.resultOverviewContainer);
      var details = document.getElementById(this.resultDetailContainer);
      if (data.mq === 'md') {

        if (details.style.display === 'block') {
          overview.setAttribute('data-flyout', true);
          details.setAttribute('data-flyout', true);
        } else {
          overview.removeAttribute('data-flyout');
          details.removeAttribute('data-flyout');
        }

      } else {
        overview.removeAttribute('data-flyout');
        details.removeAttribute('data-flyout');
      }
    }
  },
  form: {
    hide: function (opts) {
      // +++++ /GUI/form/hide +++++
      var $form = Hafas('#' + this.formContainer, false);
      Hafas.Util.gui.setVisibility($form, false);

      Hafas.ps.pub('/GUI/tabNavigationHeading/hide');
    },
    show: function (opts) {
      // +++++ /GUI/form/show +++++
      var $form = Hafas('#' + this.formContainer, false);
      var $searchButton = Hafas("[data-button='" + this.appContext + "SearchButton']");
      if ($searchButton) {
        Hafas.Util.gui.setVisibility($searchButton, true);
      }
      Hafas.Util.gui.setVisibility($form, true);
      if(!Hafas.Config.UI.showAsWebView) {
        Hafas.ps.pub('/GUI/tabNavigationHeading/show');
      }
    },
    toggleVia: function (data) {
      if (data.ev)
        data.ev.preventDefault();
      var $trigger = document.getElementById('HFS_ViaToggle');
      if (!$trigger.parentNode.className.match(/js_viaOpen/g)) {
        $trigger.parentNode.addClassName('js_viaOpen');
      } else {
        // if input contains entry, delete it!
        var $via = document.getElementById('Via');
        if ($via) {
          $via.value = '';
        }
        $trigger.parentNode.removeClassName('js_viaOpen');
      }
      Hafas.ps.pub('/app/events/resize');
    },

    // Funktion für BAIM-Optionen/ mroe
    checkRadioButtons: function (source, className) {
      var classList = document.getElementsByClassName(className);
      for (var i = 0; i < classList.length; i++) {
        classList[i].checked = false;
      }
      source.checked = true;
    }
  },
  request: {
    start: function (data) {
    },
    end: function (data) {
    },
    fail: function (data) {
    }
  },
  durationBar: {
    recalculate: function (data) {
      // Android Algorithmus: https://confluence.local.hacon.de/x/hK0oAg
      var ovDurationBarElements;
      var detDurationBarElements;

      // Einstellungen
      var forceIconWidth = Hafas.Config.TP.durationBarHorizontal.forceIconWidth;
      var forceLabelWidth = Hafas.Config.TP.durationBarHorizontal.forceLabelWidth;
      var removeOverlappingLabels = Hafas.Config.TP.durationBarHorizontal.removeOverlappingLabels;
      var overflowOverlappingLabels = Hafas.Config.TP.durationBarHorizontal.overflowOverlappingLabels;
      var centerLabels = Hafas.Config.TP.durationBarHorizontal.centerLabels;
      var barMinWidth = Hafas.Config.TP.durationBarHorizontal.barMinWidth;

      var pageContentElem = Hafas('#HFS_PageContent', false);
      // Hole bei Cluster andere Dom Elemente
      if (Hafas.Config.TP.useGrouping) {
        ovDurationBarElements = Hafas('#' + this.resultOverviewContainer + ' [data-result-conngroup="' + this.Controller.TP.visibleClusterGroup + '"] [data-render-element="durationbar_main"]', true, pageContentElem);
        detDurationBarElements = Hafas('#' + this.resultDetailContainer + ' [data-result-conngroup="' + this.Controller.TP.visibleClusterGroup + '"] [data-render-element="durationbar_main"]', true, pageContentElem);
      }

      // Ohne Cluster Overview
      if (!ovDurationBarElements || ovDurationBarElements.length === 0) {
        ovDurationBarElements = Hafas('#' + this.resultOverviewContainer + ' [data-render-element="durationbar_main"]', true, pageContentElem);
      }

      // Ohne Cluster Details
      if (!detDurationBarElements || detDurationBarElements.length === 0) {
        detDurationBarElements = Hafas('#' + this.resultDetailContainer + ' [data-render-element="durationbar_main"]', true, pageContentElem);
      }

      // Alle Durationbars zusammenfügen
      var durationBarElements = ovDurationBarElements.concat(detDurationBarElements);

      if (durationBarElements.length !== 0) {
        // Erster Schritt: Mindestbreiten setzen
        if (forceLabelWidth || forceIconWidth) {
          // Reset der Größen - damit wir die realen Breiten der Labels oder Icons bekommen
          var minWidthResetClass = 'lyr_tpResultDurBarWidthReset';
          if (!pageContentElem.classList.contains(minWidthResetClass)) {
            pageContentElem.classList.add(minWidthResetClass);
          }
          // Speichere die DomElemente vorerst in ein Array, damit DOM Lesen und Schreiben getrennt ausgeführt werden.
          var objectsSetMinWidth = [];
          var objectsSetAverageWidth = [];
          var elementsToResetWidths = [];
          // Gehe alle Perlschnüre durch
          durationBarElements.forEach(function calculateProdItemWidths(durationBarElement) {
            // Hole alle Items / Abschnitte der Duration Bar
            var prodItemsElements = Hafas('[data-render-element="durationbar_item"]', true, durationBarElement);
            var currentDurationbarArray = [];
            var widthOfLabels = 0;
            var durationBarWidth = durationBarElement.offsetWidth;
            prodItemsElements.forEach(function checkProdItemsWidth(prodItem, index) {
              var elementLengthsToCheck = [];
              // ProdLabel mittig
              var label = Hafas('[data-render-element="durationbar_line"]', false, prodItem);
              // Mindestbreite für die eingefärbten Balken
              var bar = Hafas('[data-render-element="durationbar_bar"]', false, prodItem);
              // Bei vielen Umstiegen muss hier beim Controllcontainer eine Breite gesetzt werden.
              var control = Hafas('[data-render-element="durationbar_control"]', false, prodItem);
              var labelWidth = 1;
              // Dynamische Icongröße (Start & Endicons) + Mittige Labels
              var icons = Hafas('[data-render-element="durationbar_icon"]', true, prodItem);
              var iconWidths;
              // Start- und Endicon zusammen
              var startEndIconWidth = 1;
              // Starticon
              var startIconWidth;

              // Dynamische Icongröße der IconDivs / Container
              var iconDivs = Hafas('[data-render-element="durationbar_icondiv"]', true, prodItem);

              if (label) {
                labelWidth += label.offsetWidth;
                if (forceLabelWidth) {
                  elementLengthsToCheck.push(labelWidth);
                }
              }

              if (icons.length !== 0) {
                iconWidths = icons.map(function (icon) {
                  var iconOffsetWidth = icon.offsetWidth;
                  startIconWidth = startIconWidth || iconOffsetWidth;
                  startEndIconWidth += iconOffsetWidth;
                  return iconOffsetWidth;
                });
                if (forceIconWidth) {
                  // Icons + Mindestbreite des eingefärbten Teils der Perlschnur
                  elementLengthsToCheck.push(startEndIconWidth + barMinWidth);
                }
              }

              if (elementLengthsToCheck) {
                // Größter Wert aus Array
                var itemMinWidth = Math.max.apply(null, elementLengthsToCheck) + 1;
                currentDurationbarArray.push({
                  iconDivs: iconDivs,
                  iconWidths: iconWidths,
                  minWidth: itemMinWidth,
                  averageWidth: Math.round(100 / prodItemsElements.length),
                  elementToSet: prodItem,
                  // Label unter Icon zentrieren
                  labelToCenter: label,
                  // Setzt eine Mindestbreite für den eingefärbten Balken
                  bar: bar,
                  control: control,
                  // Optisch sitzt das Label nicht mittig, daher + 0.5
                  labelMarginLeft: ((Math.round(((startIconWidth - labelWidth) / 2) * 10) / 10) + 0.5)
                });
                widthOfLabels += itemMinWidth;
              }
              elementsToResetWidths.push(prodItem);
              elementsToResetWidths.push(bar);
              elementsToResetWidths.push(control);
              elementsToResetWidths = elementsToResetWidths.concat(iconDivs);
            });
            if (widthOfLabels <= durationBarWidth) {
              // Genug Platz für alle Icons oder Labels: Mindestgröße
              objectsSetMinWidth = objectsSetMinWidth.concat(currentDurationbarArray);
            } else {
              // Nicht genug Platz für alle Icons oder Labels: Prozentuale Verteilung
              objectsSetAverageWidth = objectsSetAverageWidth.concat(currentDurationbarArray);
            }
            currentDurationbarArray = null;
          });
          // Hier werden erst die Dom Elemente manipuliert
          elementsToResetWidths.forEach(function resetWidths(element) {
            if (element.style.minWidth) element.style.minWidth = '';
            if (element.style.flexBasis) element.style.flexBasis = '';
          });
          objectsSetMinWidth.forEach(function setMinWidth(object) {
            object.elementToSet.style.minWidth = object.minWidth + 'px';

            object.iconDivs.forEach(function setIconDivMinWidth(iconDiv, index) {
              if(object.iconWidths && object.iconWidths[index]) iconDiv.style.minWidth = object.iconWidths[index] + 'px';
            });

            if (centerLabels && object.labelToCenter) object.labelToCenter.style.marginLeft = object.labelMarginLeft + 'px';
            if (object.bar) object.bar.style.minWidth = barMinWidth + 'px';

            // DOM-Referenzen entfernen
            object.elementToSet = null;
            object.labelToCenter = null;
            object.iconDivs = null;
            object.bar = null;
            object.control = null;
          });
          objectsSetAverageWidth.forEach(function setAverageWidth(object) {
            // FlexBasis übersteuert den Width-Wert
            object.elementToSet.style.flexBasis = object.averageWidth + '%';
            if (centerLabels && object.labelToCenter) object.labelToCenter.style.marginLeft = object.labelMarginLeft  + 'px';

            object.iconDivs.forEach(function setIconDivFlexBasis(iconDiv, index) {
              if(object.iconWidths && object.iconWidths[index]) iconDiv.style.flexBasis = object.iconWidths[index] + 'px';
            });

            if (object.bar) object.bar.style.flexBasis = barMinWidth + 'px';
            if (object.control) object.control.style.minWidth = '100%';

            // DOM-Referenzen entfernen
            object.elementToSet = null;
            object.labelToCenter = null;
            object.iconDivs = null;
            object.bar = null;
            object.control = null;
          });
          // Entferne ResetClass - Hier sollte erst der Paint im Browser ausgeführt werden
          if (pageContentElem.classList.contains(minWidthResetClass)) {
            pageContentElem.classList.remove(minWidthResetClass);
          }
        }

        // Zweiter Schritt: Überlappende Labels ausblenden
        if (removeOverlappingLabels || overflowOverlappingLabels || centerLabels) {
          var minWidthLabelResetClass = 'lyr_tpResultDurLabelWidthReset';
          if (!pageContentElem.classList.contains(minWidthLabelResetClass)) {
            pageContentElem.classList.add(minWidthLabelResetClass);
          }

          // Prüft ob zwei BoundingClientRects sich überlappen
          function _isOverlappingHorizontalRTL(rect1, rect2) {
            return rect1.right > rect2.left;
          }

          // Speichere die DomElemente vorerst in ein Array, damit DOM Lesen und Schreiben getrennt ausgeführt werden.
          var elementsToHide = [];
          var elementsToShow = [];
          // Gehe alle Perlschnüre durch
          durationBarElements.forEach(function removeOverlappingLabelsFn(durationBarElement) {
            // Hole alle Labels der Duration Bar
            var prodLabelElements = Hafas('[data-render-element="durationbar_line"]', true, durationBarElement);
            var index = 0;
            // gehe durch Labels
            for (index; prodLabelElements.length > index; index++) {
              var nextIndex = index + 1;
              // currLabel: X-O---O-O-O
              var currentLabelElement = prodLabelElements[index];
              // nextLabel: O-X---O-O-O
              var nextLabelElement = prodLabelElements[nextIndex];
              // Prüfe nachfolgende Labels ob sie sich überlappen
              // Es können sich mehrere Labels überlappen, daher ein while Schleife
              while (nextLabelElement && _isOverlappingHorizontalRTL(currentLabelElement.getBoundingClientRect(), nextLabelElement.getBoundingClientRect())) {
                // Beim Overflow nehmen wir das Aktuelle
                if (overflowOverlappingLabels) {
                  elementsToHide.push(currentLabelElement);
                } else if(removeOverlappingLabels) {
                  // Label überlappen sich, daher muss das darauf folgende Label ausgeblendet werden.
                  elementsToHide.push(nextLabelElement);
                  index++;
                  // nextLabel: O-_---X-O-O
                }
                if (centerLabels) elementsToHide.push(nextLabelElement);
                nextIndex++;
                nextLabelElement = prodLabelElements[nextIndex];
                // Das nächste Label wird ausgeblendet, also muss es nicht mehr betrachtet werden.
                // Index wird in der for Schleife erneut hochgezählt (insg. +2)
                // Im nächsten Durchgang wird folgendes betrachtet
                // currLabel: O-_---X-O-O
                // nextLabel: O-_---O-X-O
              }
              // Beim Vergrößern müssen die ausgeblendeten Labels auch eingeblendet werden.
              elementsToShow.push(currentLabelElement);
            }
          });
          // Und hier manipulieren wir die Dom Elemente
          elementsToShow.forEach(function showElements(prodNameEl) {
            if (removeOverlappingLabels) {
              prodNameEl.style.visibility = '';
            } else
            if (overflowOverlappingLabels) {
              prodNameEl.style.maxWidth = '';
              prodNameEl.style.overflow = '';
              prodNameEl.style.textOverflow = '';
            }
          });
          elementsToHide.forEach(function hideElements(prodNameEl) {
            if (removeOverlappingLabels) {
              prodNameEl.style.visibility = 'hidden';
            } else
            if (overflowOverlappingLabels) {
              prodNameEl.style.maxWidth = '100%';
              prodNameEl.style.overflow = 'hidden';
              prodNameEl.style.textOverflow = 'ellipsis';
            }
            // Nur negativen Margin resetten
            if (centerLabels && prodNameEl.style.marginLeft.length > 0 && prodNameEl.style.marginLeft.charAt(0) === '-') {
              prodNameEl.style.marginLeft = '';
            }
          });
          if (pageContentElem.classList.contains(minWidthLabelResetClass)) {
            pageContentElem.classList.remove(minWidthLabelResetClass);
          }
        }
      }
    }
  },
  Push: {
    currentConnection: null,
    cancel: function () {
      this.Controller.Push.Overlay.close();
    },
    showOptions: function (data) {
      var focusSelector = Hafas.Util.gui.getFocusElementSelector(); // Remember focused element to restore later

      if(!Hafas.Util.isCookieTypeActive('functional')) {
        Hafas.ps.pub('/GUI/common/showCookieSettingsHint', [['functional']]);
        return;
      }

      // Wenn Subscription Id vorliegt wird ein bestehendes Abo weiterbearbeitet
      if (data.subscrId != null) {
        Hafas.ps.pub('/push/edit', [{subscrId: data.subscrId, origin: 'TP'}]);
        return;
      }

      var currConnection;
      try {
        var results = this.Controller.TP.instance.getResults(data.connectionType);

        if (data.connectionType === 'PT') {
          currConnection = results[data.arrayIdx - 1];
        } else {
          currConnection = results[data.arrayIdx - 1].resolvedConnection;
        }
      } catch (e) {
        if (this.Controller.TP.reconstructConnection != null) {
          currConnection = this.Controller.TP.reconstructConnection;
        }
      }

      this.Controller.Push.currentConnection = currConnection;
      Hafas.bind(this.Controller.TP.showCreateNewAlarmDialog, this)({previousFocusSelector: focusSelector});
    },
    showSetupWait: function (domElem) {
      domElem.disabled = true;
      Hafas.Modules.Render.render(
      {
        template: 'Push_AtomContextMenu_AlarmTypeSpinner',
        target: domElem,
        model: {}
      }, Hafas.bind(function (html) {
        this.Controller.Push.Overlay.redraw(this.Controller.Push.Overlay);
      }, this)
      );
      //domElem.parentNode.removeChild(domElem);
    },
    toggleChannel: function (type, boolval) {
      var container = Hafas('[data-push-channel-input="' + type + '"]', false);
      Hafas.Util.gui.setVisibility(container, boolval);

      var errorMsg = Hafas('[data-push-error-type="' + type + '"]', false);
      var mainErrorContainer = Hafas('[data-push-error="main"]', false);
      var submitButtons = Hafas('[data-push="submitbuttons"]', false);
      var channelSelected = false;
      var selection = Hafas('[data-push-channelselect]', true);
      for (var s = 0; s < selection.length; s++) {
        if (selection[s].checked) {
          channelSelected = true;
        }
      }
      if (channelSelected == false) {
        mainErrorContainer.innerHTML = Hafas.Modules.i18n.get('Push.error.t_N_ChannelMinimum');
        Hafas.Util.gui.setVisibility(mainErrorContainer, true);
        Hafas.Util.gui.setVisibility(submitButtons, false);
      } else {
        Hafas.Util.gui.setVisibility(mainErrorContainer, false);
        Hafas.Util.gui.setVisibility(submitButtons, true);
      }
      Hafas.Util.gui.setVisibility(errorMsg, false);
      this.Controller.Push.Overlay.redraw(this.Controller.Push.Overlay);
    }
  },
  map: {
    /**
     * Shows the map if the layout class is small
     * @param {object} params
     * @param {string} params.template Template to be rendered as the map header actionbar
     * @method showIfMobile
     */
    showIfMobile: function(params){
      params = params || {};
      if (this.layoutClass === "small") {
        var template = params.template || 'Common_MapPageHeaderDetails';
        Hafas.ps.pub('/GUI/map/show', [{trigger: this, ev: {}, template: template}]);
      }
    },
    show: function (opts) {
      opts = opts || {};
      if(Hafas.Util.isFormBased() && opts.connectionType !== undefined){
        // Add map active css classes to section container
        var sectionContainer = Hafas('#HFS_TP_SectionWrapper_' + opts.connectionType + '_' + opts.arrayIdx,false);
        sectionContainer.addClassName('lyr_mapActive');

        // Add map active css classes to map container
        var mapContainer = Hafas('#HFS_TP_ConnectionMap_'+ opts.connectionType + '_' + opts.arrayIdx,false);
        mapContainer.addClassName('lyr_mapActive');

        var initCoord = Hafas.Core.newType("hafasCCoord", {
          lon: Hafas.Config.Maps.predefinedArea.lon,
          lat: Hafas.Config.Maps.predefinedArea.lat
        });
        var mapConfigParams = {
          coord: initCoord,
          zoom: Hafas.Config.Maps.predefinedZoom,
          reverseLookup: false,
          layer: [{
            "name": "HAFAS BaseLayer",
            "id": "HafasBaseMap",
            "type": "static",
            "url": Hafas.Config.staticTileURL,
            "attribution": "&copy; OpenStreetMap contributors",
            "isBaseLayer": true
          }],
          baseLayer: Hafas.Config.Maps.baseLayer
        };
        if (typeof Hafas.Config.Maps.controls != 'undefined') {
          mapConfigParams.controls = Hafas.Config.Maps.controls;
        }

        mapConfigParams.useContextmenu = Hafas.Config.Maps.useContextmenu;
        var map = Hafas.Core.newType("hafasMap" + Hafas.Config.Maps.mapApi, 'HFS_TP_ConnectionMap_'+ opts.connectionType + '_' + opts.arrayIdx, mapConfigParams);

        this.Controller.Map.connectionMaps['HFS_TP_ConnectionMap_'+ opts.connectionType + '_' + opts.arrayIdx] = map;

        var connResults = this.Controller.TP.instance.getResults(opts.connectionType);
        var selConnection = connResults[opts.arrayIdx].resolvedConnection;

        // Noch auszulagern:
        var connection = Hafas.Core.newType("hafasConnection", selConnection, map);
        try {
          connection.show();
          connection.centerRoute();
        }catch(e){

        }

        Hafas.Util.gui.setVisibility(Hafas("#HFS_DetailsBtn_" + opts.connectionType + "_" + opts.arrayIdx,false),true);
        Hafas.Util.gui.setVisibility(Hafas("#HFS_OverviewMapBtn_" + opts.connectionType + "_" + opts.arrayIdx,false),false);


      }else {

        // Initialize the map layers for Controller.Map.instance. If we have done that before, nothing will happen
        Hafas.ps.pub('/map/initLayer');

        // console.trace('+++++ /GUI/map/show +++++');
        var _me = this;
        var _map = document.getElementById(this.mapContainer);
        var _mapHeader = document.getElementById('HFS_PageMapHeader');
        var _mapHeaderTemplate = 'Common_MapPageHeaderDefault';

        if (typeof opts.template != 'undefined') {
          _mapHeaderTemplate = opts.template;
        }

        _mapHeader.innerHTML = '';

        _map.style.visibility = 'visible';
        _map.style.zIndex = 100000;

        // Common_MapPageHeader
        // this.mapHeaderContainer
        Hafas.Modules.Render.render(
        {
          file: 'common.map.html',
          target: _me.mapHeaderContainer,
          template: _mapHeaderTemplate,
          model: {
            appcontext: _me.appContext
          }
        },
        function (html) {
          Hafas.Util.gui.setVisibility(_mapHeader, true);
          Hafas.ps.pub('/GUI/map/mobileShow', [opts]);

          if (_me.layoutClass === "small") {
            Hafas.Util.gui.setVisibility(Hafas("#HFS_PageContent"), false);
            Hafas.Util.gui.setVisibility(Hafas("#HFS_TabNavigation"), false);
            Hafas.ps.pub('/MapSearchMobile/Init');
          }

          // track
          Hafas.ps.pub('/tracking/event/favorites-tab', ['[' + _me.appContext + '] Tab: FavMap']);
        }
        );

        if (Hafas.Modules.History)
          Hafas.Modules.History.addData(_me.appContext, "map", opts);

        if (Hafas.Modules.IFrameApi)
          Hafas.Modules.IFrameApi.sendOpenMap();
      }
    },
    hide: function (opts) {
      opts = opts || {};
      if(Hafas.Util.isFormBased() && opts.connectionType !== undefined){
        Hafas.Util.gui.setVisibility(Hafas("#HFS_DetailsBtn_" + opts.connectionType + "_" + opts.arrayIdx,false),false);
        Hafas.Util.gui.setVisibility(Hafas("#HFS_OverviewMapBtn_" + opts.connectionType + "_" + opts.arrayIdx,false),true);
        var sectionContainer = Hafas('#HFS_TP_SectionWrapper_' + opts.connectionType + '_' + opts.arrayIdx,false);
        sectionContainer.removeClassName('lyr_mapActive');
        var mapContainer = Hafas('#HFS_TP_ConnectionMap_'+ opts.connectionType + '_' + opts.arrayIdx,false);
        mapContainer.removeClassName('lyr_mapActive');
        var map = this.Controller.Map.connectionMaps['HFS_TP_ConnectionMap_'+ opts.connectionType + '_' + opts.arrayIdx];
        if(map){
          map.remove();
        }
        delete map;
        return;
      }
      var _me = this;
      // console.trace('+++++ /GUI/map/hide +++++');
      var _map = document.getElementById(this.mapContainer);
      var _mapHeader = document.getElementById('HFS_PageMapHeader');
      _map.style.visibility = 'hidden';
      _map.style.zIndex = -1;

      Hafas.Util.gui.setVisibility(_mapHeader, false);
      Hafas.ps.pub('/GUI/map/mobileHide', []);
      if (this.layoutClass == "small") {
        Hafas.Util.gui.setVisibility(Hafas("#HFS_PageContent"), true);
        Hafas.Util.gui.setVisibility(Hafas("#HFS_TabNavigation"), true);
        // disable livemap, if available
        if (typeof this.Controller.Livemap != 'undefined') {
          window.setTimeout(function () {
            Hafas.ps.pub("/livemap/clearJourneyFilter", [true, false]);
            Hafas.ps.pub('/mobilityradar/journeys/setAllProductClass/webapp', [false]);
            Hafas.ps.pub('/livemap/stop');
          }, 20);
        }
        if (Hafas.Modules.IFrameApi)
          Hafas.Modules.IFrameApi.sendHideMap();
      }
    },
    setDimension: function (params) {
      // +++++ /GUI/map/setDimension +++++
      // Abhängig von der config muss die referenzhöhe ermittelt werden
      // entweder vom Viewport (window) oder des WebApp-Containers (HFS_WebApp)
      var _me = this;
      var $webappWrap = Hafas('#' + this.webappWrap, false),
      webAppH = window.innerHeight;

      if (!Hafas.Config.Switches.useMediaQueries || !Hafas.Config.UI.forceLayoutClass) {
        webAppH = $webappWrap.offsetHeight;
      }

      if (Hafas.Config.UI.showPageHeader)
        var pageHeaderHeight = Hafas("#HFS_PageHeader").clientHeight;
      else
        var pageHeaderHeight = 0;

      // Elements
      var $mapContainer = Hafas('#' + this.mapContainer, false),
      $tabNavi = Hafas('#HFS_TabNavigation', false),
      $fieldsetWrapper = Hafas('[data-render-element="fieldset_wrapper"]', false),
      $optionsWrapperTabs = Hafas('#DocumentOptionsWrapper .hfs_controlTabWrapper', false);

      // Elements Heights
      var mapContainer_H = $mapContainer.offsetHeight,
      tabNavi_H = $tabNavi.offsetHeight,
      fieldsetWrapper_H = $fieldsetWrapper.offsetHeight,
      optionsWrapperTabs_H = $optionsWrapperTabs.offsetHeight;

      // addiere die Höhen
      var usedHeight = pageHeaderHeight + tabNavi_H + fieldsetWrapper_H + optionsWrapperTabs_H;

      // subtrahiere von der möglichen Maximalhöhe
      var available_H = webAppH - usedHeight;

      $mapContainer.style.zIndex = 19999;
      $mapContainer.style.position = 'fixed';
      $mapContainer.style.top = usedHeight + 'px';

      if (Hafas.Config.UI.forceLayoutClass) {
        var _me = this;
        if (this.layoutClass == "small") {
          // get MapContainer as HTML-Element
          var $mapView = Hafas('#' + _me.mapContainer, false);
          var $mapViewHeader = Hafas('#' + _me.mapContainer + ' .lyr_pageMapHeader', false);
          $mapViewHeader.innerHTML = "";

          var $resDetailResult = Hafas('#DocumentOptionsWrapper .hfs_controlContentWrapper', false);
          var top = $resDetailResult.offsetTop;

          $mapView.style.top = top + "px";
          $mapView.style.left = 0;
          $mapView.style.zIndex = 1000000;
          $mapView.style.height = (window.innerHeight - top - 1) + 'px';
          $mapView.addClassName('js_singleViewMode');

          this.Controller.Map.updateSize();
        }

        if (typeof this.Controller.Map.connection != 'undefined' && this.Controller.Map.connection != null) {
          this.Controller.Map.connection.centerRoute();
        }
      }

      $mapContainer.addClassName("js_mapTabActive");
      $mapContainer.removeClassName("js_mapTabInactive");

      this.Controller.Map.updateSize();
    },
    resetDimension: function (params) {
      // +++++ /GUI/map/resetDimension +++++
      // Elements
      var $mapContainer = Hafas('#' + this.mapContainer, false);
      $mapContainer.removeAttribute('style');
      $mapContainer.addClassName("js_mapTabInactive");
      $mapContainer.removeClassName("js_mapTabActive");
      if (Hafas.Config.Switches.useMap) {
        this.Controller.Map.updateSize();
      }
    }
  },
  sq: {
    toggleResultTab: function (mode) {
    },
    closeAllMiniStboard: function () {
      var targetContainer = Hafas('[data-toolbox-stationboard]', true);
      var checkboxElement = Hafas('.hfs_mapToolbox input[data-toggle-btn="miniStboard"]', false);
      targetContainer.forEach(function (elem) {
        Hafas.Util.gui.setVisibility(elem, false);
      });
      if (checkboxElement) {
        checkboxElement.checked = false;
      }
    },
    toggleMiniStboard: function (show, data) {
      // Neue Toggle-Funktion mit ARIA-Attributen (Barrierefreiheit)
      Hafas.ps.pub('/GUI/common/atomToggleContainer', [data]);
    },
    toggleMiniStboardFilter: function (show, data) {
      // Neue Toggle-Funktion mit ARIA-Attributen (Barrierefreiheit)
      Hafas.ps.pub('/GUI/common/atomToggleContainer', [data]);
    },
    toggleNearStations: function (show, data) {
      // Neue Toggle-Funktion mit ARIA-Attributen (Barrierefreiheit)
      Hafas.ps.pub('/GUI/common/atomToggleContainer', [data]);
    }
  },
  eventsearch: {
    toggleMiniEventBoard: function (show, data) {
      // Neue Toggle-Funktion mit ARIA-Attributen (Barrierefreiheit)
      Hafas.ps.pub('/GUI/common/atomToggleContainer', [data]);
    }
  },
  fullscreen: {
    toggle: function (action, elem) {
      Hafas.Util.fullscreen.toggle(action, elem);
    }
  },
  smallAlert: {
    show: function (text, button) {

      var alert = Hafas("#HFS_SmallAlert");
      // Wird über den Announcer benachrichtig, daher aria-hidden auf true
      alert.innerHTML = "<div class='lyr_text' aria-hidden='true'>" + text + "</div>";
      alert.addClassName("lyr_show");

      window.setTimeout(function() {
        alert.addClassName("lyr_fadeIn");
      },1);
      Hafas.Modules.a11y.Announce.assertive(text);

      setTimeout(function () {
        alert.removeClassName("lyr_show");
        alert.removeClassName("lyr_fadeIn");
      }, 5000);
    },
    hide: function(){
      var alert = Hafas("#HFS_SmallAlert");
      alert.removeClassName("lyr_show");
      alert.removeClassName("lyr_fadeIn");
    }
  }
};
